import { render, staticRenderFns } from "./schoolMealFilters.vue?vue&type=template&id=3dde3501&scoped=true"
import script from "./schoolMealFilters.vue?vue&type=script&lang=js"
export * from "./schoolMealFilters.vue?vue&type=script&lang=js"
import style0 from "./schoolMealFilters.vue?vue&type=style&index=0&id=3dde3501&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dde3501",
  null
  
)

export default component.exports